import React, { useState, useEffect } from 'react'
import Footer from '../../components/Common/Footer'
import Header from '../../components/Header/Header'
import AppModule from '../../App.module.scss'
import ManagementScreen from '../../components/ManagementScreen/ManagementScreen'
import { _prompt_type_choice_NANDE } from '../../localConstant'
import TocIcon from '@mui/icons-material/Toc'
import { useNavigate, useSearchParams } from 'react-router-dom'
import { doc, getDoc } from 'firebase/firestore'
import { auth, db } from '../../firebase'
import { useAuthState } from 'react-firebase-hooks/auth'
import LoadingGrid from '../../components/LoadingGrid/LoadingGrid'

function Management() {
  const [searchParams] = useSearchParams()
  const schoolId = searchParams.get('school_id') // クエリパラメータから取得
  const muid = searchParams.get('muid')
  const navigate = useNavigate()
  const [isLoading, setIsLoading] = useState(true)
  const [user] = useAuthState(auth)
  const listItem = [
    { name: '会話データ', path: schoolId ? `/chat_data?school_id=${schoolId}` : `/chat_data`, icon: <TocIcon /> }
  ]

  useEffect(() => {
    const fetchUserData = async () => {
      if (!user) {
        setIsLoading(false)
        return
      }
      try {
        const userRef = doc(db, 'users', user.uid)
        const userDoc = await getDoc(userRef)
        if (userDoc.exists()) {
          const userData = userDoc.data()
          if (userData.hasOwnProperty('schoolDocId') && userData.schoolDocId !== schoolId) {
            alert('他のスクールの管理画面にアクセスできません')
            navigate('/')
          } else if (!userData.hasOwnProperty('schoolDocId') && !!schoolId) {
            alert('管理人はスクールの管理画面にアクセスできません')
            navigate('/')
          }
        }
      } catch (error) {
        console.error('Error fetching user data: ', error)
      } finally {
        setIsLoading(false)
      }
    }

    fetchUserData()
  }, [user, navigate])

  return (
    <div className={AppModule.main}>
      <Header title="モード管理" listItem={listItem} />
      {isLoading ? (
        <LoadingGrid />
      ) : (
        <ManagementScreen serviceType="gpt-teacher" prompt_type_choice={_prompt_type_choice_NANDE} />
      )}
      <Footer />
    </div>
  )
}
export default Management
